
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.661 42.507l2.882 13.048 51.526-3.206-2.41-13.776-51.998 3.934z","fill":"#91BCFF"}}),_c('path',{attrs:{"d":"M53.988 4v15.528h15.476","stroke":"#000","stroke-linejoin":"bevel"}}),_c('path',{attrs:{"d":"M65.81 75.993H13.732L13.719 4h40.27l15.475 14.864V76l-4.17-.007","stroke":"#000"}}),_c('path',{attrs:{"d":"M20.35 13.794h15.214M20.35 18.643h8.586M20.35 39.566l28.235-.337M20.35 47.318h42.484M20.35 55.227h8.586M20.35 61.674h15.214","stroke":"#000","stroke-linejoin":"bevel"}})])
          )
        }
      }
    